import React, { useEffect, useState } from 'react';
import { Button, Modal, Typography, Image, Divider, Space } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { start_loading, end_loading } from 'src/core/actions/loader';
import newAlert from 'src/components/newAlert';
import axios from 'src/core/utils/axios';
import dayjs from 'dayjs';

const { Text } = Typography;

const QpayModal = ({
  visible = true,
  onCancel = () => {},
  paymentData,
  fetch = () => {},
}) => {
  const dispatch = useDispatch();
  const [paymentInfo, setPaymentInfo] = useState(paymentData || null);
  const [checking, setChecking] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(null);

  const { socket, data_date } = useSelector((state) => state);

  // Setup timer and payment info on open or paymentData change
  useEffect(() => {
    if (visible && paymentData) {
      setPaymentInfo(paymentData);

      // Calculate expiration time (use backend or fallback to 5 mins)
      const expireAt = paymentData.expiration_time
        ? dayjs(paymentData.expiration_time)
        : dayjs().add(5, 'minute');
      const now = dayjs();
      const sec = Math.max(0, expireAt.diff(now, 'second'));
      setSecondsLeft(sec);

      const timer = setInterval(() => {
        setSecondsLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            newAlert({
              type: 'warning',
              msg: 'Төлбөрийн хугацаа дууслаа!',
            });
            onCancel();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
    setSecondsLeft(null);
  }, [visible, paymentData, onCancel]);

  const checkPaymentStatus = async () => {
    if (!socket) return;

    socket.removeAllListeners('request_out');
    dispatch(start_loading({}));

    const handleResponse = (data) => {
      if (
        String(data.status) === '0' &&
        String(data.content?.payment_status) === '0'
      ) {
        // Paid!
        newAlert({
          type: 'success',
          msg: data.content?.Message || 'Төлбөр амжилттай хийгдсэн байна',
        });
        onCancel();
        fetch();
      } else if (
        String(data.status) === '0' &&
        String(data.content?.payment_status) === '1'
      ) {
        // Pending!
        newAlert({
          type: 'warning',
          msg: data.content?.Message || 'Төлбөр хараахан баталгаажаагүй байна',
        });
      } else {
        newAlert({
          type: 'error',
          msg: data.content?.Message || 'Төлбөр шалгах үед алдаа гарлаа',
        });
      }
      dispatch(end_loading({}));
    };

    socket.on('request_out', handleResponse);

    const requestData = {
      channel: 'hh01_view',
      content: {
        action_type: 'check_qpay_payment',
        page: 1,
        size: 25,
        search: {},
        code: paymentInfo?.code,
      },
    };

    if (!paymentInfo?.code) {
      newAlert({ type: 'warning', msg: 'Төлбөрийн дугаар олдсонгүй.' });
      dispatch(end_loading({}));
      return;
    }

    socket.emit('request_in', requestData);
  };

  return (
    <Modal
      className="custom-modal"
      title="Төлбөрийн мэдээлэл"
      open={visible}
      width={500}
      footer={null}
      onCancel={onCancel}
      destroyOnClose
    >
      {paymentInfo?.qr_code ? (
        <>
          <div style={{ textAlign: 'center' }}>
            <Image
              width={200}
              src={`data:image/png;base64,${paymentInfo.qr_code}`}
              alt="QR Code"
              preview={false}
            />
            <Text
              strong
              style={{ display: 'block', marginTop: 12, fontSize: 18 }}
            >
              Төлөх дүн:{' '}
              <span style={{ color: '#1677ff', fontWeight: 700 }}>
                {paymentInfo.amount || '—'}
              </span>
              ₮
            </Text>
            <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
              Төлбөрийн QR код
            </Text>
            {secondsLeft !== null && (
              <Text
                type={secondsLeft <= 30 ? 'danger' : 'warning'}
                style={{ display: 'block', marginTop: 8, fontSize: 16 }}
              >
                Хугацаа: {Math.floor(secondsLeft / 60)}:
                {(secondsLeft % 60).toString().padStart(2, '0')}
              </Text>
            )}
          </div>

          <Divider />
          <Space style={{ width: '100%', justifyContent: 'center' }}>
            <Button onClick={onCancel}>Хаах</Button>
            <Button
              className="confirm-btn"
              type="primary"
              onClick={checkPaymentStatus}
              loading={checking}
            >
              QPay төлбөр шалгах
            </Button>
          </Space>
        </>
      ) : (
        <Text>Төлбөрийн мэдээлэл олдсонгүй.</Text>
      )}
    </Modal>
  );
};

export default QpayModal;
